const baseCanonicalUrl = 'https://www.owndays.com/sg/en/articles';
const baseImageUrl = 'https://static.lenskart.com/owndays/img/articles';

export const ARTICLES = [
  {
    metaTitle: 'Your Guide To Adjusting To Progressive Lenses Effortlessly',
    targetPath: '/articles/guide-to-adjusting-to-progressive-lenses',
    keywords:
      'Progressive lenses,Progressive lens price Singapore,Progressive lens SingaporeProgressive glasses, Spectacle frames,What are progressive lenses,Best progressive lenses Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/img/articles/sg-001/ogp_1200x630.jpg',
    description: `As you adjust to your progressive lenses, it is normal to experience a difference. Let us share how to get used to your new progressive lenses effortlessly.`,
    canonicalUrl: `${baseCanonicalUrl}/guide-to-adjusting-to-progressive-lenses`,
  },
  {
    metaTitle: 'How to Manage Myopia and Prevent It from Worsening',
    targetPath: '/articles/manage-myopia-and-prevent-it-from-worsening',
    keywords:
      'Prescription glasses,Myopia control lenses,Glasses degree,Myopia lens, Prescription glasses online,Bugis spectacle shop,OWNDAYS',
    ogImage: 'https://static.lenskart.com/owndays/img/articles/sg-002/ogp_1200x630-20250425.jpg',
    description: `While there is no known cure for myopia, prescription glasses and myopia control lenses can manage this vision-related condition and prevent it from worsening.`,
    canonicalUrl: `${baseCanonicalUrl}/manage-myopia-and-prevent-it-from-worsening`,
  },
  {
    metaTitle: 'Top 4 Signs That Indicate You Should Get Your Eyes Checked',
    targetPath: '/articles/4-signs-that-indicate-you-should-get-your-eyes-checked',
    keywords: 'Free eye test,eye exam,eye checkup Singapore,eye screening Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/owndays/img/articles/sg-003/ogp_1200x630.jpg',
    description: `Undergoing regular eye tests is crucial in maintaining your eye health. If you experience the following signs, you should schedule an eye examination.`,
    canonicalUrl: `${baseCanonicalUrl}/4-signs-that-indicate-you-should-get-your-eyes-checked`,
  },
  {
    metaTitle: 'Presbyopia: What You Need To Know About This Eye Condition ',
    targetPath: '/articles/what-you-need-to-know-about-presbyopia',
    keywords:
      'Presbyopia,Presbyopia symptoms,Age-related vision changes,Presbyopia correction options,Understanding presbyopia causes,Eye health after 40,Contact lenses,Eyeglasses,Eye test,Contact lens,Singapore,Progressive lenses,OWNDAYS',
    ogImage: 'https://static1.lenskart.com/owndays/img/articles/sg-004/ogp_1200x630-20250425.jpg',
    description: `Presbyopia is a refractive error that occurs as part of the natural ageing process. Let us share more about the condition and what you can do to mitigate it.`,
    canonicalUrl: `${baseCanonicalUrl}/what-you-need-to-know-about-presbyopia`,
  },
  {
    metaTitle: 'Why It Is Important To Get Your Eye Prescription Right',
    targetPath: '/articles/why-it-is-important-to-get-your-eye-prescription-right',
    keywords:
      'Eye prescription,Spectacles Singapore,Prescription glasses,Spectacle shop Singapore,Eye test,OWNDAYS',
    ogImage: 'https://static.lenskart.com/owndays/img/articles/sg-005/ogp_1200x630-20250425.jpg',
    description: `If you notice your vision is blurry even with glasses on, consider getting your eye prescription checked. Learn why accurate prescription is important here!`,
    canonicalUrl: `${baseCanonicalUrl}/why-it-is-important-to-get-your-eye-prescription-right`,
  },
  {
    // SG006
    metaTitle:
      'What Is Better For Myopia Control: Glasses Or Contact Lens? | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/articles/what-is-better-for-myopia-control-glasses-or-contact-lens',
    keywords:
      'Myopia lens,Prescription glasses online,Prescription lenses,Myopia control lenses,Best glasses for short sightedness,Best optical shop in Singapore,OWNDAYS',
    ogImage: `${baseImageUrl}/sg-006/ogp_1200x630.jpg`,
    description:
      'Wondering if glasses or contacts are better for myopia control? Learn how each option helps manage short-sightedness and which could be the right choice for you.',
    canonicalUrl: `${baseCanonicalUrl}/what-is-better-for-myopia-control-glasses-or-contact-lens`,
  },
  {
    // SG007
    metaTitle:
      'Contact Lenses Vs. Glasses: Which Is More Affordable? | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/articles/which-is-more-affordable-contact-lenses-or-glasses',
    keywords:
      'contact lenses,glasses,eyewear,lens,cost comparison,affordability,long-term cost,budget analysis,expenses,Singapore,OWNDAYS',
    ogImage: `${baseImageUrl}/sg-007/ogp_1200x630.jpg`,
    description:
      'Comparing the cost of contact lenses vs glasses? Find out which option is more affordable long-term by looking at upfront, maintenance, and replacement costs.',
    canonicalUrl: `${baseCanonicalUrl}/which-is-more-affordable-contact-lenses-or-glasses`,
  },
  {
    metaTitle: 'Tips for Eyewear, Contact Lenses & Eye Care',
    targetPath: '/articles',
    keywords:
      'blog,tips,information,eyeglasses,sunglasses,eyewear,fashion,contact lens,book free eye test,stores,articles,Singapore,OWNDAYS',
    ogImage: null,
    description: `Discover expert tips on choosing the right eyewear, caring for contact lenses, and maintaining eye health. Stay informed with the latest trends and advice from OWNDAYS.`,
    canonicalUrl: `${baseCanonicalUrl}`,
  },
];
